import { MoldOrderWithMold } from '../types/mold';

/** Highest priority first, then the work that has been open longest. */
export const sortMyWork = <T extends MoldOrderWithMold>(orders: T[]): T[] =>
  [...orders].sort((a, b) => {
    const priorityDifference = (a.priority ?? Number.MAX_SAFE_INTEGER) -
      (b.priority ?? Number.MAX_SAFE_INTEGER);
    if (priorityDifference !== 0) return priorityDifference;

    const openedDifference = new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    if (openedDifference !== 0) return openedDifference;

    return (a.id ?? 0) - (b.id ?? 0);
  });
